/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const roadmapMilestoneDtoSchema = z.object({
  when: z.optional(z.string()),
  title: z.optional(z.string()),
  description: z.optional(z.string()),
  status: z.optional(z.enum(["Done", "Current", "Planned"]).default("Done")),
});
